module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1506-9542f357a577a4c48a203910f659930b.png";